import { fetchAPI } from ".";

export const getPressMedia = async (startPage, pageSize, filters) => {
  try {
    const pressMedia = await fetchAPI(`/press-medias`, {
      filters,
      populate: {
        category: "*",
        title: "*",
        description: "*",
        featured: "*",
        file: "*",
        slug: "*",
        image: "*",
        press_media_category: "*",
        PressMedia_keywords: "*",
      },
      sort: [
        {
          id: "desc",
        },
      ],
      fields: "*",
      pagination: {
        page: startPage,
        pageSize,
      },
    });
    //console.log("blogRes",blogsRes)
    // printObj(blogs, "blogs obj from getHectareBlogs()");
    return pressMedia;
  } catch (err) {
    console.log(err);
  }
};

export const getFilteredPressMedia = async (filters) => {
  try {
    const pressMedia = await fetchAPI("/press-medias", {
      filters,
      sort: [
        {
          id: "desc",
        },
      ],
      populate: {
        category: "*",
        title: "*",
        description: "*",
        featured: "*",
        file: "*",
        image: "*",
        slug: "*",
        press_media_category: "*",
        pressMedia_keywords: "*",
      },
    });
    return pressMedia;
  } catch (err) {
    console.log(err);
  }
};
